export class LocationCoordinate {
    constructor(lat = 0, lng = 0) {
        this.lat = lat;
        this.lng = lng;
    }
    isEmpty() {
        return this.lat === 0 && this.lng === 0;
    }
}
export class LocationManager {
}
